import type { ComponentProps } from 'react';

import type { SelfVideoThumbnail } from '../SelfVideoThumbnail';

type SelfVideoThumbnailPreset = ComponentProps<typeof SelfVideoThumbnail>;

export const MOBILE_SELF_VIDEO_THUMBNAIL_PRESET: SelfVideoThumbnailPreset = {
  showExpandVideoToggle: false,
  shouldShowHideSelf: false,
  showSetPositionMenu: false,
  className: 'sm:hidden relative self-center mt-2 mb-6 sm:mt-10 sm:mb-10',
  videoClassName:
    'min-h-[12rem] sm:min-h-[14rem] max-h-[18rem] min-w-[calc(100vw-2rem)] sm:min-w-[25rem] max-w-screen-sm',
};

export const DESKTOP_SELF_VIDEO_THUMBNAIL_PRESET: SelfVideoThumbnailPreset = {
  showExpandVideoToggle: true,
  shouldShowHideSelf: true,
  showSetPositionMenu: true,
  className: 'hidden sm:inline absolute',
};
